import VConsole from 'vconsole';

if (process.env.REACT_APP_VCONSOLE) {
	new VConsole();
}

type GlobalContainerProps = {
	children: React.ReactNode;
};
const GlobalContainer = ({ children }: GlobalContainerProps) => {
	return <>{children}</>;
};

export default GlobalContainer;
